<template>
  <div class="schedule mb-4">
    <v-row dense>
      <v-col cols="6">
        <div
          :id="`form-schedule-field-${tag.name}-typ-${uniqid}`"
          class="schedule-typ"
        >
          <v-select
            v-model="schedule.typ"
            dense
            outlined
            :items="[
              { value: 0, text: 'Интервал' },
              { value: 1, text: 'Выбор дат' },
              { value: 2, text: 'Неопределенная дата' }
            ]"
            label="Тип расписания"
            hide-details
            class="mb-4"
            :attach="`#form-schedule-field-${tag.name}-typ-${uniqid}`"
            :menu-props="{
              nudgeBottom: 40
            }"
          />
        </div>
      </v-col>
    </v-row>
    <v-row v-if="schedule.typ == 0" dense class="schedule-dates-interval mt-0">
      <v-col cols="6" class="schedule-dates-interval-begin mb-4">
        <date-select
          v-model="schedule.dt_begin"
          label="Начало"
          format="dd.MM.yyyy"
          :readonly="readonly"
          :attach-id="`form-date-field-${tag.name}-begin-${uniqid}`"
        />
      </v-col>
      <v-col cols="6" class="schedule-dates-interval-end mb-4">
        <date-select
          v-model="schedule.dt_end"
          label="Окончание"
          format="dd.MM.yyyy"
          :readonly="readonly"
          :attach-id="`form-date-field-${tag.name}-end-${uniqid}`"
        />
      </v-col>
    </v-row>
    <div v-if="schedule.typ == 1" class="schedule-dates-select mb-4">
      <validation-provider
        v-slot="{ errors }"
        rules="required"
        eager
        name="Даты"
      >
        <date-array
          v-model="schedule.dates"
          :readonly="readonly"
          :attach-id="`form-date-field-${tag.name}-dates-${uniqid}`"
          :error-messages="errors"
        />
      </validation-provider>
    </div>
    <div v-if="schedule.typ == 2" class="schedule-dates-undefined mb-4">
      <v-text-field
        v-model="schedule.text"
        label="Замещающий текст"
        outlined
        dense
        hide-details
      />
    </div>
    <div class="schedule-times">
      <time-array
        v-model="schedule.times"
        :readonly="readonly"
        :attach-id="`form-date-field-${tag.name}-times-${uniqid}`"
      />
    </div>
  </div>
</template>

<script>
import DateArray from "@/components/DateArray.vue";
import DateSelect from "@/components/DateSelect.vue";
import TimeArray from "@/components/TimeArray.vue";
import uniqueId from "lodash/uniqueId";

export default {
  components: {
    DateSelect,
    DateArray,
    TimeArray
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        typ: 0,
        dt_begin: "",
        dt_end: "",
        dates: [],
        times: []
      })
    },
    tag: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      date: ""
    };
  },
  computed: {
    schedule: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    uniqid() {
      return uniqueId();
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/styles/branding.scss";
.schedule {
  position: relative;
  .schedule-typ {
    position: relative;
  }
}
</style>
